import { useTranslation } from "react-i18next";

/** "3 agents and 1 chat", pluralized per language. */
export function useDescribeUsage() {
  const { t } = useTranslation("adminModels");
  return (agents: number, chats: number) =>
    t("usage.both", { agents: t("usage.agents", { count: agents }), chats: t("usage.chats", { count: chats }) });
}
